// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"37px","--gray-1":"#a3a3a3","--gray-2":"#a0a0a0","--gray-3":"#c4c4c4","--gray-4":"#c0c0c0","--gray-5":"#9b9b9b","--gray-6":"#303030"};